import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ThemeCssVariablesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ThemeCssVariablesPublicAPI> {
    return {
        methods: {
            theme: {
                colors: {
                    getAll: publicMethodUtils.extensionPublicAPI.getter('theme.getColorsConsideringGlobalVariables')
                },
                fonts: {
                    getAll: publicMethodUtils.extensionPublicAPI.getter('theme.getFontsConsideringGlobalVariables'),
                    getMap: publicMethodUtils.extensionPublicAPI.getter(
                        'theme.getThemeFontsMapConsideringGlobalVariables'
                    ),
                    getCharacterSet: publicMethodUtils.extensionPublicAPI.getter('theme.getCharacterSet'),
                    updateCharacterSet: publicMethodUtils.extensionPublicAPI.immediate('theme.updateCharacterSet')
                }
            }
        }
    }
}
